var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import ListItem from './ResultItem';
import mergeClassnames from '../../../mergeClassnames/mergeClassnames';
import { SearchContext } from '../utils/context';
const NoResults = (_a) => {
    var { label = 'Search for', className } = _a, props = __rest(_a, ["label", "className"]);
    const { search } = useContext(SearchContext);
    return (React.createElement(ListItem, Object.assign({ index: 0, showType: false }, props),
        React.createElement("span", { className: mergeClassnames('max-w-md truncate text-bulma', className) },
            label,
            " ",
            React.createElement("span", { className: "font-medium" },
                "\"",
                search,
                "\""))));
};
export default NoResults;
